import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import BuilderSelect from "@/store/builderStoreSelector";
import RoomLayoutBuilder from "./twoDLayout/RoomLayoutBuilder";
import { actions as builderActions } from "@/store/builderSlice";
import RoomView from "./RoomView";
import { TwoDRoomLayout } from "@/store/builderSlice";
import { DimensionalViewType } from "@/utils/builder/builderConstants";
import { useRouter } from "next/router";

const RoomTypeView = (
) => {
    const dispatch = useDispatch();
    const switchTo3DViewOnLoad = useRef(false);
    // const urlParams: { [key: string]: string } = BuilderSelect.ui().urlParams;

    const router = useRouter()
    const urlParams = router.query
    
    const isCustomRoomFlow: boolean = BuilderSelect.ui().isCustomRoomFlow;
    const currentRoomId: string = BuilderSelect.activeSelection().roomId;
    const isEditFlow = urlParams.projectId != null;
    const twoDRoomLayout: TwoDRoomLayout = BuilderSelect.twoDRoomLayout();
console.log("roomtypeview:", isCustomRoomFlow);

    useEffect(() => {
        if (!switchTo3DViewOnLoad.current && twoDRoomLayout.boundingRect != null && twoDRoomLayout.boundingRect.width > 0) {
            switchTo3DViewOnLoad.current = true;
            dispatch(builderActions.updateLayoutBuilderMode({ layoutBuilderMode: DimensionalViewType.THREE_D }));
        }
    }, [twoDRoomLayout.boundingRect]);

    if (currentRoomId === '' && !isCustomRoomFlow) return <></>

    return <>
        {isCustomRoomFlow ? (<RoomLayoutBuilder />) : <RoomView urlParams={urlParams} />}
    </>
}

export default RoomTypeView;